export default __webpack_public_path__ + "static/media/IBK기업.e935f499.svg";